// extracted by mini-css-extract-plugin
export var acitonButtons = "_gj-0";
export var additionalIcon = "_gj-f";
export var block = "_gj-1";
export var blockContent = "_gj-7";
export var blockDescription = "_gj-8";
export var blockIcon = "_gj-9";
export var blockTitle = "_gj-6";
export var border = "_gj-a";
export var center = "_gj-l";
export var edge = "_gj-b";
export var edgeLabel = "_gj-c";
export var edgePath = "_gj-d";
export var error = "_gj-e";
export var flowchart = "_gj-g";
export var flowchartContent = "_gj-h";
export var highlighted = "_gj-3";
export var hover = "_gj-4";
export var icon = "_gj-i";
export var left = "_gj-m";
export var navButton = "_gj-j";
export var navButtons = "_gj-k";
export var right = "_gj-n";
export var selected = "_gj-2";
export var small = "_gj-5";